import { AthonStoreItem } from '@givebacks/api/store';
import { useBreakPoints } from 'core';
import { toTitleCase } from 'core/Utils';
import { Alert, SegmentedControl, Stack, Title } from 'ui';

type AthonDonationTypeButtonsProps = {
  onChange?: (value: string) => void;
  isPledge?: boolean;
  unitsOfActivity?: AthonStoreItem['units_of_activity_singular'];
};
const AthonDonationTypeButtons = ({
  onChange,
  isPledge,
  unitsOfActivity,
}: AthonDonationTypeButtonsProps) => {
  const { isXSmallScreen } = useBreakPoints();

  const athonCartType = isPledge ? 'pledge_required' : 'initialized';

  return (
    <Stack>
      <Title order={4}>Donation Type</Title>
      <SegmentedControl
        data={[
          {
            label: `Per-${toTitleCase(unitsOfActivity ?? '')}`,
            value: 'pledge_required',
          },
          {
            label: `Flat Amount`,
            value: 'initialized',
          },
        ]}
        variant="light"
        orientation={isXSmallScreen ? 'vertical' : 'horizontal'}
        w="100%"
        value={athonCartType}
        onChange={(value) => {
          onChange?.(value);
        }}
      />
      <Alert.Collapse type="info-blue" in={athonCartType == 'pledge_required'}>
        Click "Buy Now" to make your pledge donation. Pledges can not be added to a cart with other
        items.
      </Alert.Collapse>
    </Stack>
  );
};

export { AthonDonationTypeButtons };
